function startCase(input: string): string {
  return input
    .replace(/[\W_]+/g, ' ') // Replace non-alphanumeric characters with spaces
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert spaces before uppercase letters
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // Insert spaces inside consecutive uppercase letters
    .replace(/\b\w/g, (match) => match.toUpperCase()) // Capitalize the first character of each word
    .trim(); // Remove leading/trailing spaces
}

export { startCase };
